import { Box, CardContent, Stack } from "@mui/material";
import { Avatar, Card, Text } from "@src/appV2/redesign/system/ui-components";
import type { ReactNode } from "react";

interface PlacementChatMessageLayoutProps {
  message: ReactNode;
  button?: ReactNode;
}

export function PlacementChatMessageLayout({ message, button }: PlacementChatMessageLayoutProps) {
  return (
    <Stack direction="row" alignItems="flex-start" gap={2} sx={{ py: 5 }}>
      <Avatar size="small" fallbackIconType="clipboard-bunny-colored" />
      <Stack spacing={1}>
        <Box sx={{ px: 2 }}>
          <Text bold variant="body2" sx={{ color: "text.primary" }}>
            Clipboard
          </Text>
        </Box>
        <Card variant="primary">
          <CardContent>
            <Text variant="body2" sx={{ color: "text.primary", whiteSpace: "pre-wrap" }}>
              {message}
            </Text>
            {button}
          </CardContent>
        </Card>
      </Stack>
    </Stack>
  );
}
